import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#9BBE60"
      d="M22.5 19.688h-1.687v-8.855a1.32 1.32 0 0 0-.425-.968l-7.5-7.077-.009-.007a1.307 1.307 0 0 0-1.765 0l-.008.007-7.5 7.078a1.31 1.31 0 0 0-.418.967v8.855H1.5a.563.563 0 0 0 0 1.125h21a.562.562 0 1 0 0-1.125M4.313 10.833a.19.19 0 0 1 .06-.139l.009-.007 7.494-7.077a.19.19 0 0 1 .247 0l7.495 7.078.008.007a.19.19 0 0 1 .061.139v8.854h-4.875V15a1.313 1.313 0 0 0-1.312-1.312h-3A1.313 1.313 0 0 0 9.188 15v4.688H4.312zm9.375 8.855h-3.376V15a.19.19 0 0 1 .188-.187h3a.19.19 0 0 1 .188.187z"
    />
  </svg>
);
export default SvgHome;
